// src/components/Navbar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../App.css";

const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  // ✅ Function to trigger phone call
  const handleCall = () => {
    window.location.href = "tel:+447508667276";
  };

  return (
    <>
      <header className="navbar">
        <div className="navbar-inner">
          {/* Logo block */}
          <div className="nav-logo">
            <img
              src={require("../images/logo.png")}
              alt="Ndils Daily Care Logo"
              className="nav-logo-img"
            />
            <div className="nav-logo-text">
              <span className="nav-logo-title">Ndils</span>
              <span className="nav-logo-subtitle">Daily Care</span>
            </div>
          </div>

          {/* Center links (desktop) */}
          <nav className="nav-main">
            <ul className="nav-links">
              <li>
                <NavLink
                  to="/"
                  end
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/about"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  About
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/services"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Services
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/recruitment"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Recruitment
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </nav>

          {/* Right – Request Care button (desktop) */}
          <div className="nav-right">
            <button className="request-btn" onClick={handleCall}>
              {/* ✅ call action */}
              <span className="request-btn-icon">📞</span>
              <span>Request Care</span>
            </button>
          </div>

          {/* Hamburger icon (mobile) */}
          <button
            type="button"
            className="hamburger"
            aria-label="Open navigation menu"
            onClick={openDrawer}
          >
            ☰
          </button>
        </div>
      </header>

      {/* MOBILE DRAWER + BACKDROP */}
      <div
        className={
          isDrawerOpen ? "drawer-backdrop visible" : "drawer-backdrop"
        }
        onClick={closeDrawer}
      />

      <aside
        className={isDrawerOpen ? "mobile-drawer open" : "mobile-drawer"}
      >
        <div className="drawer-header">
          <button
            type="button"
            className="drawer-close"
            aria-label="Close navigation menu"
            onClick={closeDrawer}
          >
            ×
          </button>
        </div>

        <ul className="drawer-links">
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeDrawer}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeDrawer}
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/services"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeDrawer}
            >
              Services
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/recruitment"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeDrawer}
            >
              Recruitment
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeDrawer}
            >
              Contact
            </NavLink>
          </li>
        </ul>

        {/* Request care pinned at bottom in drawer */}
        <button
          type="button"
          className="drawer-request-btn"
          onClick={handleCall}   // ✅ now calls directly
        >
          Request Care
        </button>
      </aside>
    </>
  );
};

export default Navbar;
